var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	61528: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	39651: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	32511: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	69882: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022__browser-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	47996: {
		fallback: () => (__webpack_require__.e("node_modules_axios_index_js").then(() => (() => (__webpack_require__(/*! axios */ 21672))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.19.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",

	},
	84424: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_axios_axios"), __webpack_require__.e("default-webpack_sharing_consume_default_mbcon_state-data_mbcon_state-data"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @mbcon/configuration */ 9245))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mbcon/configuration",

	},
	43543: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__element-chunk_mjs-node_modules_angular_cdk_fesm202-d0e635"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__fake-event-detection-chunk_mjs-node_modules_angula-00b7bb"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__focus-key-manager-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__form-field-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__focus-monitor-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_scrolling_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__overlay-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__pseudo-checkbox-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_a11y_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__option-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_autocomplete_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/autocomplete */ 79771))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/autocomplete",

	},
	58705: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__element-chunk_mjs-node_modules_angular_cdk_fesm202-d0e635"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__fake-event-detection-chunk_mjs-node_modules_angula-00b7bb"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__focus-key-manager-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__form-field-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__focus-monitor-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_chips_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/chips */ 12772))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/chips",

	},
	84819: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__element-chunk_mjs-node_modules_angular_cdk_fesm202-d0e635"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__fake-event-detection-chunk_mjs-node_modules_angula-00b7bb"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__pseudo-checkbox-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__option-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__id-generator-chunk_mjs-node_modules_angular_cdk_fe-bc0ab7")]).then(() => (() => (__webpack_require__(/*! @angular/material/core */ 74646))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/core",

	},
	67079: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__element-chunk_mjs-node_modules_angular_cdk_fesm202-d0e635"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__fake-event-detection-chunk_mjs-node_modules_angula-00b7bb"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__focus-key-manager-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__form-field-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__focus-monitor-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_scrolling_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__overlay-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_a11y_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_datepicker_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/datepicker */ 61977))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/datepicker",

	},
	69581: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__element-chunk_mjs-node_modules_angular_cdk_fesm202-d0e635"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__fake-event-detection-chunk_mjs-node_modules_angula-00b7bb"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__focus-key-manager-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__focus-monitor-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_expansion_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/expansion */ 19322))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/expansion",

	},
	96439: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__element-chunk_mjs-node_modules_angular_cdk_fesm202-d0e635"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__form-field-chunk_mjs"), __webpack_require__.e("node_modules_angular_material_fesm2022_form-field_mjs-_1aed0")]).then(() => (() => (__webpack_require__(/*! @angular/material/form-field */ 24950))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/form-field",

	},
	50959: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__element-chunk_mjs-node_modules_angular_cdk_fesm202-d0e635"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__form-field-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_input_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/input */ 95541))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/input",

	},
	39151: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__element-chunk_mjs-node_modules_angular_cdk_fesm202-d0e635"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__fake-event-detection-chunk_mjs-node_modules_angula-00b7bb"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__focus-key-manager-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__focus-monitor-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_scrolling_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__overlay-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_menu_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/menu */ 31034))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/menu",

	},
	86127: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_scrolling_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_table_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/table */ 77697))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/table",

	},
	78485: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022__browser-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations */ 43835))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",

	},
	20045: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	61461: {
		fallback: () => (__webpack_require__.e("libs_shared_product-config_dp-module-config_src_index_ts").then(() => (() => (__webpack_require__(/*! @cbl/dp-module-config */ 63031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@cbl/dp-module-config",

	},
	62769: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_mbcon_user-context_mbcon_user-context"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @cbl/dp-user-context-config */ 70956))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@cbl/dp-user-context-config",

	},
	28384: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @mbcon/config-keys-config */ 32431))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mbcon/config-keys-config",

	},
	82780: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @mbcon/ui-notification */ 87145))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mbcon/ui-notification",

	},
	1690: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_ngx-translate_core_fesm2022_ngx-translate-core_mjs")]).then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 48503))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngx-translate/core",

	},
	23426: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_workbench_angular_fesm2022_workbench-angular_mjs")]).then(() => (() => (__webpack_require__(/*! @workbench/angular */ 80197))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.2.21",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@workbench/angular",

	},
	84050: {
		fallback: () => (__webpack_require__.e("node_modules_lodash_lodash_js").then(() => (() => (__webpack_require__(/*! lodash */ 46227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "4.18.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lodash",

	},
	48196: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	15589: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	9101: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	85593: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	96900: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	8575: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	18087: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_animations_fesm2022_browser_mjs").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	14379: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_axios_axios"), __webpack_require__.e("default-webpack_sharing_consume_default_mbcon_state-data_mbcon_state-data"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @mbcon/user-context */ 5971))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mbcon/user-context",

	},
	13992: {
		fallback: () => (__webpack_require__.e("default-node_modules_mbcon_state-data_src_index_js").then(() => (() => (__webpack_require__(/*! @mbcon/state-data */ 62833))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mbcon/state-data",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		61528
	],
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		39651
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop": [
		32511
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		69882
	],
	"default-webpack_sharing_consume_default_axios_axios": [
		47996
	],
	"default-webpack_sharing_consume_default_mbcon_configuration_mbcon_configuration": [
		84424
	],
	"dp-packages_apps_shell_src_bootstrap_ts": [
		43543,
		58705,
		84819,
		67079,
		69581,
		96439,
		50959,
		39151,
		86127,
		78485,
		20045,
		61461,
		62769,
		28384,
		82780,
		1690,
		23426,
		84050
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		48196
	],
	"default-node_modules_angular_core_fesm2022__resource-chunk_mjs": [
		15589,
		9101
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		85593
	],
	"default-webpack_sharing_consume_default_angular_forms_angular_forms": [
		96900
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		8575
	],
	"default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser": [
		18087
	],
	"default-webpack_sharing_consume_default_mbcon_user-context_mbcon_user-context": [
		14379
	],
	"default-webpack_sharing_consume_default_mbcon_state-data_mbcon_state-data": [
		13992
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}